import { handlePostAction } from "../../../utils/event-api-invoke";
import { getItineraryTimesAPIPostSchema, getItineraryTimesAPIDeleteSchema, getItineraryTimesAuditInfoSchema } from "../create/Schema";

let _isError = false;

const getAuditInfo = (data, auditConfig) => {
  try {
    let _auditSchema = getItineraryTimesAuditInfoSchema();
    let _currentState = {};
    let _prevState = {};
    let _isDeleted = data?.Deleted;
    Object.keys(data).forEach((key) => { //If the record is deleted, previousState will be available. The currentState will be available for creation.
      if (_isDeleted) {
        if (key !== "Deleted") { //We do not send deleted key in state
          _prevState[key] = data[key];
        }
      } else {
        if (key === "DeviceType") {
          _currentState[key] = data[key].label;
          _prevState[key] = auditConfig.formdata?.[key].label;
        } else {
          _currentState[key] = data[key];
          _prevState[key] = auditConfig.formdata?.[key]; //formdata will only be available in edit scenario
        }
      }
    });

    _auditSchema.auditInfo[0].shortDesc = _isDeleted ? data?.DeviceType : data?.DeviceType?.label;
    _auditSchema.auditInfo[0].currentState = JSON.stringify(_currentState);
    _auditSchema.auditInfo[0].previousState = JSON.stringify(_prevState);
    if (auditConfig.EditItineraryTimesId) {
      _auditSchema.auditInfo[0].LocationKey = auditConfig.EditItineraryTimesId;
      _auditSchema.auditInfo[0].Action = _isDeleted ? "DELETE" : "EDIT";
    } else {
      _auditSchema.auditInfo[0].Action = "CREATE";
    }

    return _auditSchema;
  } catch (err) {
    _isError = true;
    alert(err);
  }
};

const getPostPayload = (data, config) => {
  try {

    let _isDeleted = data?.Deleted;
    let _postSchema = {};
    if (_isDeleted) {
      _postSchema = getItineraryTimesAPIDeleteSchema(config.countryCode, config.businessCode);

      _postSchema.itineraryTimes[0].ItineraryTimesId = config.EditItineraryTimesId;
      _postSchema.itineraryTimes[0].Deleted = _isDeleted;

    } else {
      _postSchema = getItineraryTimesAPIPostSchema(config.countryCode, config.businessCode);

      _postSchema.itineraryTimes[0].DeviceTypeId = data?.DeviceType.id || "";
      _postSchema.itineraryTimes[0].Jorney = data?.Jorney || "";
      _postSchema.itineraryTimes[0].Percentage1 = data?.Percentage1 || 0;
      _postSchema.itineraryTimes[0].Percentage2 = data?.Percentage2 || 0;

      if (config.EditItineraryTimesId) {
        _postSchema.itineraryTimes[0].ItineraryTimesId = config.EditItineraryTimesId;
      }
    }


    return _postSchema;
  } catch (err) {
    _isError = true;
    alert(err);
  }
};

const saveItineraryTimes = async (data, uihandler) => {
  let status = {
    responseStatus: null,
    error: null,
  };
  const {
    EditItineraryTimesId,
    settingsConfig: { businessCode, countryCode },
    formdata
  } = uihandler;
  try {
    let _auditInfo = getAuditInfo(data, { EditItineraryTimesId, formdata });
    let _postPayload = getPostPayload(data, { EditItineraryTimesId, businessCode, countryCode });

    let _postRequest = { ..._postPayload, ..._auditInfo };

    let res = await handlePostAction(_postRequest, "itineraryTimes");
    if (res && res.status && res.status === 200) {
      if (res.data.errorNumber > 0) {
        _isError = true;
        status.errorMessage = res.data.errorDescription;
      } else {
        status.responseStatus = res.status;
      }
    }

  } catch (err) {
    _isError = true;
    alert(err);
  } finally {
    return { ...status, error: _isError };
  }
};

export { saveItineraryTimes };
